import { isEmpty } from 'lodash-es';
import { isDeviceSummary, isPlotSummary } from '../../resources/measurements.type';
import { keysOf } from '../../utils';
import { getIsVirtualDeviceAndMeasurementConfig } from './useMetricProvider';
function getCountByMetric(summary) {
    const countByMetric = new Map();
    const isVirtualDeviceByMetric = new Map();
    let measures = [];
    const resource = isPlotSummary(summary)
        ? summary.metadata.plot
        : isDeviceSummary(summary)
            ? summary.metadata.device
            : summary.metadata.station;
    if ('currentMeasurementConfigs' in resource) {
        const summaryDataKeys = keysOf(summary.data);
        const hasHDEFInKeys = !isEmpty(summaryDataKeys) && summaryDataKeys.some((key) => key.includes('HDEF'));
        measures = resource.currentMeasurementConfigs.map((conf) => {
            return conf.metric;
        });
        if (hasHDEFInKeys) {
            measures.push('HDEF');
        }
    }
    else if ('availableMeasures' in resource) {
        measures = resource.availableMeasures;
    }
    measures.forEach((metric) => {
        countByMetric.set(metric, 1);
        const { isVirtualDevice } = getIsVirtualDeviceAndMeasurementConfig({
            resource,
            metric
        });
        isVirtualDeviceByMetric.set(metric, isVirtualDevice);
    });
    return { countByMetric, isVirtualDeviceByMetric };
}
export default getCountByMetric;
